import React from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { SnackbarProvider as NotistackSnackbarProvider, SnackbarKey } from 'notistack';

/**
 * Uses notistack lib, which simplifies usage of Mui Snackbar.
 */
const SnackbarProvider: React.FC = (props) => {
  const notistackRef = React.createRef<NotistackSnackbarProvider>();
  const { t } = useTranslation();
  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key);
  };

  return (
    <NotistackSnackbarProvider
      ref={notistackRef}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={8000}
      action={(key: SnackbarKey) => (
        <Button onClick={onClickDismiss(key)} color="inherit">
          <b>{t('generic.dismiss')}</b>
        </Button>
      )}
    >
      {props.children}
    </NotistackSnackbarProvider>
  );
};

export default SnackbarProvider;
